module.exports = __webpack_public_path__ + "static/media/faq-page.eaae6562.jpg";